module.exports = __webpack_public_path__ + "assets/a2dbd4e1592592f9d3a18f52ebb3345d.mp3";